const MuiInputLabel = {
  filled: {
    '&$shrink': {
      transform: 'translate(15px, 0) scale(0.75)'
    }
  },
  outlined: {
    '&$shrink': {
      transform: 'translate(0, 4px) scale(0.75)'
    }
  }
};
export default MuiInputLabel;